import type {
  MergeDecisionDto,
  MergePeriodDto,
  MergeRowDto,
} from '../api/mergeResolution.types';
import { CUSTOM_VALUE_MAX_LEN } from '../config';

import { isLegal } from './legality';

export function validateCustomValue(
  raw: string
): { ok: true; value: string } | { ok: false; reason: string } {
  const trimmed = raw.trim();

  // Check empty, length, and line breaks.
  if (
    trimmed.length === 0 ||
    trimmed.length > CUSTOM_VALUE_MAX_LEN ||
    trimmed.includes('\n') ||
    trimmed.includes('\r')
  ) {
    return {
      ok: false,
      reason: 'Enter a value of 1–50 characters on one line',
    };
  }

  return { ok: true, value: trimmed };
}

export function customDecision(
  row: MergeRowDto,
  period: MergePeriodDto,
  value: string
): MergeDecisionDto | null {
  if (!isLegal(period, 'CUSTOM')) {
    return null;
  }

  return {
    input_row_id: row.Input_RowID,
    date_id: period.DateID,
    choice: 'CUSTOM',
    custom_value: value,
  };
}

export function clearDecision(
  row: MergeRowDto,
  period: MergePeriodDto
): MergeDecisionDto | null {
  if (!isLegal(period, 'CLEAR')) {
    return null;
  }

  return {
    input_row_id: row.Input_RowID,
    date_id: period.DateID,
    choice: 'CLEAR',
  };
}
